<template>
    <div style="height: calc(100vh - 70px);">
        <div v-if="orderId" :key="orderId">
            <order-form @closeOrder="clearOrderId()" :orderId="this.orderId" :key="orderId" @printOrder="printOrder($event)" />
        </div>
<div class="d-flex flex-column" style="height: calc(100vh - 70px);" v-else>



<b-container fluid>
            <b-row>
                <b-col>
                    <order-search :filters="filters"
                                  :searchText="searchText"
                                  @search="doSearch"
                                  @clear="resetFilters"
                                  @removeFilter="removeFilter"
                                  @refreshSearch="refreshSearch"></order-search>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <order-menu :selected="selected"
                                :rowCount="searchResults.length"
                                :selectRange="selectRange"
                                :busy="creatingOrder"
                                @selectAll="$refs.ordersTable.selectAllRows()"
                                @clearSelected="$refs.ordersTable.clearSelected()"
                                @printSelected="printSelected()"
                                @previewInvoice="previewInvoice()"
                                @sendInvoice="sendInvoice()"
                                @newOrder="newOrder()"
                                @setSelectRange="setSelectRange()"
                                @refresh="refreshSearch()"
                                @createCustomerFromOrder="createCustomerFromOrder()"
                                @pullList="pullList()"
                                @removeCombined="removeCombined()"
                                >

                                </order-menu>
                              
                </b-col>
            </b-row>
        </b-container>

        <b-container fluid class="flex-grow-1 p-0 m-0 overflow-auto">
            <b-table sticky-header="100vh" primary-key="order" selectable small no-border-collapse
                    class="h-100 m-0 pb-4"
                     :select-mode="(selectRange ? 'range' : 'multi')"
                     :items="provider"
                     :fields="fields"
                     @row-selected="rowSelected"
                     ref="ordersTable"
                     id="ordersTable"
                     :busy.sync="isLoading"
                     >

                <template #cell(orderId)="row">
                    <b-link append @click="openOrder(row.value)">{{ row.value }}</b-link>
                </template>

                <template #[`cell(customer.customerId)`]="row">
                    <b-link v-if="row.value" :to="{ name: 'customers', params: { outsideQuery: { customerId: row.value} } }" append>{{ row.value }}</b-link>
                </template>

                <template #cell(orderTotal)="data">
                    <span class="text-success">
                        ${{ data.value ? data.value.toFixed(2) : '0' }}
                    </span>
                </template>

                <template #cell(shipping)="data">
                    <h5 class="mb-0 text-primary" v-if="data.value" ><b-icon-check-circle-fill></b-icon-check-circle-fill></h5>
                    <h5 class="mb-0 text-secondary" v-else><b-icon-x-circle-fill></b-icon-x-circle-fill></h5>
                </template>

                <template #cell(printing)="data">
                    <span class="text-secondary">
                        <b-button class="print-tooltip-button" :id='data.item._id' v-if="data.value" size="sm" variant="link"><h5 class="mb-0 text-primary" style="width: 20px; height: 20px; font-size: 100%;"><b-icon-check-circle-fill class="mt-0" style="width: 20px; height: 20px;"></b-icon-check-circle-fill></h5>
                            <b-tooltip v-if="data.item._id" :target='data.item._id' triggers="hover" placement="bottom" variant="primary">
                            <span>Printed <span v-if="data.item.printing[0] && data.item.printing[0].username"> by <strong>{{ data.item.printing[0].username }}</strong></span> on <strong v-if="data.item.printing[0] && data.item.printing[0].date">{{moment(data.item.printing[0].date).format('M/D/YYYY h:mma')}}</strong> </span>
                        </b-tooltip>
                        </b-button>

                        <h5 class="mb-0 text-secondary" v-else><b-icon-x-circle-fill></b-icon-x-circle-fill></h5>
                    </span>
                </template>

                <template #table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="mx-3" v-if="creatingOrder">Creating Order...</strong>
                        <strong class="mx-3" v-else>Loading...</strong>
                    </div>
                </template>
            </b-table>
    </b-container>



    </div>
    <print-view id="printView"
                    :print-trigger="printTrigger"
                    :orders="selected"
                    @moveToWarehouse="moveToWarehouse()"
                    v-on:printed="handlePrintJob()"></print-view>
    <orders-pull-list
        id="ordersPullList"
        class="print-list"
        :items="pullListItems"
        :order-ids="pullListOrderIds"
    ></orders-pull-list>
</div>
</template>

<script>
    import ordersApi from "../api/orders";
    import inventoryApi from "../api/inventory";
    import customersApi from "../api/customers";
    import searchMixin from "../mixins/search";
    import moment from "moment";
    import OrderSearch from "../components/orders/OrderSearch";
    import OrderMenu from "../components/orders/OrderMenu";
    import PrintView from "../components/orders/PrintView";
    import OrdersPullList from "../components/orders/OrdersPullList";
    import utils from "../mixins/utils";
    import OrderForm from '../components/orders/OrderForm';

    export default {
        name: "Orders",
        mixins: [ ordersApi, searchMixin, inventoryApi, customersApi, utils ],
        components: { OrderSearch, OrderMenu, PrintView, OrderForm, OrdersPullList },
        props: [ 'outsideQuery' ],
        data() {
            return {
                orders: [],
                fields: [
                    { key: 'orderId', label: 'Order', sortable: true, sortDirection: 'desc' },
                    {
                        key: 'platform.date',
                        label: 'Date',
                        formatter: date => {
                            if (date) {
                                return moment(date).format('M/D/YYYY h:mma');
                            }

                            return '';
                        },
                        sortable: true, sortDirection: 'desc'
                    },
                    { key: 'customer.fullName', label: 'Name'  },
                    { key: 'customer.address.line1', label: 'Address'  },
                    { key: 'customer.customerId', label: 'ID'},
                    { key: 'platform.site', label: 'Site', sortable: true },
                    {
                        key: 'orderTotal',
                        label: 'Total',
                    },
                    { key: 'location', label: 'Location' },
                    {
                        key: 'printing',
                        label: 'Printed',
                        formatter: printed => printed && printed.length,
                    },
                    {
                        key: 'shipping',
                        label: 'Shipped',
                        formatter: shipping => shipping.shipments && shipping.shipments.length,
                    },
                ],
                selected: [],
                selectRange: false,
                printTrigger: 0,
                isBusy: false,
                filters: {
                    isNewOrder: false,
                    unprinted: false,
                    paid: false,
                    unpaid: false,
                    hasOpenOrders: false,
                    shipped: false,
                    unshipped: false,
                    hasRefund: false,
                    queue: false,
                    location: null,
                    platform: null,
                    platformId: null,
                    domestic: false,
                    international: false,
                    ebayUsername: null,
                    discogsUsername: null,
                    transactionId: null,
                    trackingNumber: null,
                    shippingMethod: null,
                    customerCountry: null,
                    customerCity: null,
                    customerState: null,
                    itemQuantity: null,
                    shipDate: null,
                    shipDateTo: null,
                    shippedBy: null,
                    customerId: null,
                    noCustomerId: false,
                    zeroQtyItems: false,
                },
                searchText: '',
                searchResults: [],
                searchQuery: {},
                isLoading: false,
                creatingOrder: false,
                lastSearch: null,
                orderId: null,
                doNotSetOrderId: false,
                pullListItems: [],
                pullListOrderIds: [],
            }
        },
        created() {
            this.resetFilters();
        },
        activated() {
            if (this.outsideQuery) {
                if (this.outsideQuery.orderId) {
                    this.resetFilters();             
                    this.lastSearch = {query: this.outsideQuery.orderId.toString(), filters: {}};
                    this.searchText = this.outsideQuery.orderId.toString();
                    return this.orderId = this.outsideQuery.orderId;
                }
                else {
                    this.resetFilters();
                    return this.handleRoute();
                }
            }
        },
        methods: {
            openOrder(id) {
                this.orderId = id;
            },
            clearOrderId() {   
                this.isLoading = false;
                this.selected = [];
                this.refreshSearch();         
            },
            refreshSearch() {
                this.orderId = null;
                if (this.lastSearch) {
                    this.doNotSetOrderId = true;
                    this.searchQuery = this.lastSearch;

                    // refresh orders table refs at next tick
                    this.$refs.ordersTable?.refresh();
                }
            },
            async previewInvoice() {
                try {
                    let orderId = this.prepareOrderIdsForInvoice();

                    await this.emailPreviewInvoice(orderId);
                    this.showToast('Invoice Preview', 'Sent to your email.');
                } catch (err) {
                    this.showError(err, 'Invoice Preview');
                }
            },
            async sendInvoice() {
                try {
                    let orderId = this.prepareOrderIdsForInvoice();
                    await this.emailInvoice(orderId);
                    this.showToast('Invoice Sent', 'Success!');
                } catch (err) {
                    this.showError(err, 'Invoice');
                }
            },
            prepareOrderIdsForInvoice() {
                let orderId;

                if (this.selected.length) {
                    orderId = this.selected.map(select => {
                        return select.orderId;
                    }).join(',');
                } else {
                    orderId = this.detailsOrder.orderId;
                }

                return orderId;
            },
            resetFilters() {
                this.filters = {
                    isNewOrder: false,
                    unprinted: false,
                    paid: false,
                    unpaid: false,
                    hasOpenOrders: false,
                    shipped: false,
                    unshipped: false,
                    hasRefund: false,
                    queue: false,
                    location: null,
                    platform: null,
                    platformId: null,
                    domestic: false,
                    international: false,
                    ebayUsername: null,
                    discogsUsername: null,
                    transactionId: null,
                    trackingNumber: null,
                    shippingMethod: null,
                    customerCountry: null,
                    customerCity: null,
                    customerState: null,
                    itemQuantity: null,
                    shipDate: null,
                    shipDateTo: null,
                    shippedBy: null,
                    customerId: null,
                    noCustomerId: false,
                    zeroQtyItems: false,
                }
            },
            async handleRoute() {
                this.searchText = this.outsideQuery.query;

                if (this.outsideQuery.filters) {
                    this.filters = Object.assign({}, this.filters, this.outsideQuery.filters)
                }

                this.doSearch(this.outsideQuery);
            },
            printSelected() {
                this.printTrigger = this.printTrigger + 1;
            },
            async printOrder(orderToPrint) {
                this.selected = [];
                // fetch the order with enrichedData;
                let searchObj = { q: orderToPrint.orderId, enrichItems: true };
                const order = await this.getOrders(searchObj);
                // should return one order since it is finding by orderId
                this.$set(this.selected, 0, order[0]);
                this.$nextTick(() => {
                    this.printSelected();
                });
            },
            rowSelected(rows) {
                this.selected = rows;
            },
            setSelectRange() {
                this.selectRange = !this.selectRange;
            },
            isSearchQueryEmpty() {
                // if this.search.query is an empty object return true
                if (Object.keys(this.searchQuery).length === 0) {
                    return true;
                }
                // Check if this.searchQuery.query is an empty string or null
                const isQueryEmpty = !this.searchQuery.query || !!this.searchQuery.q;

                // Check if this.searchQuery.filters has only null or false values
                const areFiltersEmpty = !this.searchQuery.filters || Object.values(this.searchQuery.filters).every(value => !value);

                // Return true if both conditions are met, false otherwise
                return isQueryEmpty && areFiltersEmpty;
            },
            async provider(ctx) {
                if (this.isSearchQueryEmpty()) {
                    return [];
                }
                if (Object.keys(this.searchQuery).length > 0) {
                    try {
                        this.isLoading = true;
                        this.lastSearch = this.searchQuery;
                        const searchObj = this.buildSearchObject(this.searchQuery);
                        if (searchObj.isNewOrder === true) {
                            searchObj.sort = 'location';
                        } else {
                            searchObj.sort = 'orderId'
                            searchObj.dir = 'desc';
                        }
                        if (ctx.sortBy && ctx.sortBy.length) {
                            searchObj.sort = ctx.sortBy;
                            searchObj.dir = ctx.sortDesc ? 'desc' : 'asc';
                        }
                        let results = await this.getOrders(searchObj);
                        // Apply client-side Queue filter to match invoice "Q" logic
                        if (this.searchQuery && this.searchQuery.filters && this.searchQuery.filters.queue) {
                            results = results.filter(order => {
                                const items = Array.isArray(order.items) ? order.items : [];
                                const total = items.reduce((acc, item) => {
                                    const price = item && item.details && item.details.listing && item.details.listing.price ? item.details.listing.price : 0;
                                    const quantity = item && item.details && item.details.quantity ? item.details.quantity : 0;
                                    return acc + (price * quantity);
                                }, 0);
                                const method = (order.shipping && order.shipping.method ? order.shipping.method : '').toLowerCase();
                                const isPriority = method.includes('priority');
                                const isAmazon = order.platform && order.platform.site === 'Amazon';
                                return total >= 100 || isPriority || isAmazon;
                            });
                        }
                        if (results.length === 1 && !this.doNotSetOrderId) {
                            this.orderId = results[0].orderId;
                        }
                        this.doNotSetOrderId = false;

                        this.searchResults = results;
                        return results;
                    } catch (error) {
                        this.showError(error, 'Orders Error');
                        console.log(error);
                        
                        return [];
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            async doSearch(search) {
                this.isBusy = true;
                this.orderId = null;
                this.searchQuery = search || '';
                this.lastSearch = search;
                this.$refs.ordersTable?.refresh();
                this.isBusy = false;
            },
            async handlePrintJob() {
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i].location !== "Review" || this.selected[i].location !== "Manual Review") {
                        continue;
                    }

                    for (let k = 0; k < this.orders.length; k++) {
                        if (this.selected[i].orderId === this.orders[k].orderId) {
                            if (!this.orders[k].printing) {
                                this.orders[k].printing = [];
                            }

                            this.orders[k].printing.push({
                                username: this.$auth.user.nickname
                            });
                        }
                    }
                }
            },
            async moveToWarehouse() {
                this.isLoading = true;

                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i].location !== "Review" && this.selected[i].location !== "Manual Review") {
                        await this.updateOrder(this.selected[i].orderId, { location: 'Warehouse' });

                        for (let k = 0; k < this.orders.length; k++) {
                            if (this.selected[i].orderId === this.orders[k].orderId) {
                                this.orders[k].location = 'Warehouse';
                            }
                        }
                    }
                }
                this.isLoading = false;
            },
            async newOrder() {
                let date = Date.now();

                if (this.selected.length) {
                    this.creatingOrder = true;
                    this.isLoading = true;
                    const order = await this.createOrder({ platform: { date: date },
                                                           customer: this.selected[0].customer,
                                                           shipping: { method: this.selected[0].shipping.method },
                                                        });
                    this.isLoading = false;
                    this.creatingOrder = false;
                    this.orderId = order.orderId;

                } else {
                    this.creatingOrder = true;
                    this.isLoading = true;
                    const order = await this.createOrder({ platform: { date: date }, customer: { address: { line1: '' } }});
                    this.isLoading = false;
                    this.creatingOrder = false;
                    this.orderId = order.orderId;
                }
            },
            async createCustomerFromOrder() {
                if (this.selected.length !== 1) {
                    return;
                }

                const order = this.selected[0];
                const orderCustomer = order.customer;

                if (!orderCustomer) {
                    this.showError(new Error('Order does not have customer data'), 'Create Customer');
                    return;
                }

                try {
                    this.isLoading = true;
                    
                    // Build customer object from order data
                    // Start with just fullName (required for creation)
                    const customerData = {
                        fullName: orderCustomer.fullName || ''
                    };

                    // Handle email - could be string, array, or undefined
                    if (orderCustomer.email) {
                        if (Array.isArray(orderCustomer.email)) {
                            customerData.email = orderCustomer.email;
                        } else {
                            customerData.email = [orderCustomer.email];
                        }
                    }

                    // Handle phone - could be string, array of objects, or undefined
                    if (orderCustomer.phone) {
                        if (Array.isArray(orderCustomer.phone)) {
                            // If array, check if items are objects with 'number' property or strings
                            customerData.phone = orderCustomer.phone.map(p => 
                                typeof p === 'string' ? { number: p } : p
                            );
                        } else if (typeof orderCustomer.phone === 'string') {
                            customerData.phone = [{ number: orderCustomer.phone }];
                        } else if (orderCustomer.phone.number) {
                            customerData.phone = [orderCustomer.phone];
                        }
                    }

                    // Handle address - could be object or array
                    if (orderCustomer.address) {
                        if (Array.isArray(orderCustomer.address)) {
                            customerData.address = orderCustomer.address;
                        } else {
                            customerData.address = [orderCustomer.address];
                        }
                    }

                    // Create the customer with minimal data first
                    const newCustomer = await this.createCustomer({ fullName: customerData.fullName });
                    
                    // Update with all the other data if we have it
                    if (customerData.email || customerData.phone || customerData.address) {
                        const updateData = {};
                        if (customerData.email) updateData.email = customerData.email;
                        if (customerData.phone) updateData.phone = customerData.phone;
                        if (customerData.address) updateData.address = customerData.address;
                        
                        await this.updateCustomer(newCustomer.customerId, updateData);
                    }
                    
                    this.showToast('Customer Created', `Customer ID: ${newCustomer.customerId}`);
                    
                    // Navigate to the customer details page
                    this.$router.push({ 
                        name: 'customers', 
                        params: { outsideQuery: { customerId: newCustomer.customerId } } 
                    });
                } catch (err) {
                    this.showError(err, 'Create Customer');
                } finally {
                    this.isLoading = false;
                }
            },
            async pullList() {
                if (!this.selected.length) {
                    return;
                }

                // Collect items from selected orders
                const items = [];
                const orderIds = [];

                this.selected.forEach(order => {
                    if (!order || !order.orderId) {
                        return;
                    }

                    orderIds.push(order.orderId);

                    if (!order.items || !order.items.length) {
                        return;
                    }

                    order.items.forEach(orderItem => {
                        if (orderItem.status && orderItem.status.type === 'removed') {
                            return;
                        }

                        const details = orderItem.details || {};
                        if (!details.listing) {
                            return;
                        }

                        items.push({
                            ...details,
                            itemId: details.itemId,
                            listingIndex: typeof details.listingIndex === 'number' ? details.listingIndex : 0,
                        });
                    });
                });

                // Sort by location using the same rules as helpers/locationSort.sortByLocation()
                items.sort((a, b) => {
                    let locA = a.listing && a.listing.location ? a.listing.location : '';
                    let locB = b.listing && b.listing.location ? b.listing.location : '';

                    if (!locA) {
                        return -1;
                    }

                    if (!locB) {
                        return 1;
                    }

                    locA = locA.toLowerCase();
                    locB = locB.toLowerCase();

                    const splitA = locA.match(/[a-zA-Z]+|[0-9]+/g);
                    const splitB = locB.match(/[a-zA-Z]+|[0-9]+/g);

                    if (locA.length > locB.length) {
                        return 1;
                    } else if (locA.length < locB.length) {
                        return -1;
                    }

                    if (splitA[0] === splitB[0]) {
                        if (splitA[1] > splitB[1]) {
                            return 1;
                        } else if (splitA[1] < splitB[1]) {
                            return -1;
                        } else {
                            if (!splitA[2]) {
                                return 0;
                            }

                            if (splitA[2] > splitB[2]) {
                                return 1;
                            } else if (splitA[2] < splitB[2]) {
                                return -1;
                            } else {
                                if (!splitA[3]) {
                                    return 0;
                                }

                                if (splitA[3] > splitB[3]) {
                                    return 1;
                                } else if (splitA[3] < splitB[3]) {
                                    return -1;
                                }

                                return 0;
                            }
                        }
                    } else {
                        if (splitA[0] > splitB[0]) {
                            return 1;
                        } else if (splitA[0] < splitB[0]) {
                            return -1;
                        }
                    }

                    return 0;
                });

                this.pullListItems = items;
                this.pullListOrderIds = orderIds;

                this.$nextTick(() => {
                    this.$htmlToPaper('ordersPullList', {
                        styles: [
                            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                            'https://unpkg.com/kidlat-css/css/kidlat.css',
                            './assets/itemPrint.css'
                        ]
                    }, () => {});
                });
            },
            async removeCombined() {
                if (!this.selected.length) return;
                try {
                    this.isLoading = true;
                    for (const order of this.selected) {
                        const flags = { ...(order.flags || {}), unmerged: false };
                        await this.updateOrder(order.orderId, { flags });
                    }
                    this.showToast('Remove Combined', `Updated ${this.selected.length} order(s).`);
                    this.refreshSearch();
                } catch (err) {
                    this.showError(err, 'Remove Combined');
                } finally {
                    this.isLoading = false;
                }
            },
        },
        watch: {
            outsideQuery(query) {
                if (query) {
                    this.handleRoute();
                }
            }          
        }
    }
</script>

<style scoped>
    #printView {
        position: absolute;
        left: -9999px;
        top: -9999px;
    }

    .print-list {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    .overflow-auto {
        overflow: auto;
    }

    .print-tooltip-button {
        margin: 0;
        padding: 0;
    }


</style>